import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IExhibitorMeetingRatingsState } from '@app-store/slices/meetingStatistics/exhibitorMeetingRatings'

interface TaskAction extends Action {
    payload: IExhibitorMeetingRatingsState
}

const { onRequest, onSuccess, onFailure } = rootActions.meetingStatistics.exhibitorMeetingRatings

function* exhibitorMeetingRatingsSagaTask({ payload }: TaskAction) {
    try {
        const response = yield axios.get(`/meeting/stats/exhibitor/ratings`)
        if (response.success) {
            yield put(onSuccess(response.result))
            yield payload?.sagaCB && payload.sagaCB?.onSuccess()
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
        yield payload?.sagaCB && payload.sagaCB?.onError()
    }
}

function* exhibitorMeetingRatingsSaga(): any {
    yield takeLatest<TaskAction>(onRequest, exhibitorMeetingRatingsSagaTask)
}

export default exhibitorMeetingRatingsSaga
